import React from 'react';
import { useLayoutContext } from 'contexts/LayoutContext';
import api from 'lib/trpcClient';
import { CurrencyCode } from 'further-types/lp/vehicle';
import TransferLinkedCapitalActionsContent from './TransferLinkedCapitalActionsContent';
import { CalendarDay } from 'further-ui/utils';
import { useFormContext } from 'react-hook-form';
import { PartnerTransfersFormValues } from '../../hooks/usePartnerTransfersForm';

const TransferLinkedCapitalActions: React.FC<{
  partnerTransferId: string;
  baseCurrency: CurrencyCode;
  onNext: () => void;
  onPrevious: () => void;
}> = ({ partnerTransferId, baseCurrency, onNext, onPrevious }) => {
  const { selectedVehicleId } = useLayoutContext();
  const { getValues } = useFormContext<PartnerTransfersFormValues>();

  const [capitalActions] =
    api.partnerTransfers.getLinkedCapitalActions.useSuspenseQuery(
      {
        partnerTransferId,
        vehicleId: selectedVehicleId ?? '',
      },
      {
        staleTime: 0,
        gcTime: 0,
      },
    );

  const transferDate = getValues('transferDate') ?? new CalendarDay(new Date());

  return (
    <TransferLinkedCapitalActionsContent
      partnerTransferId={partnerTransferId}
      transferDate={transferDate}
      capitalActions={capitalActions ?? []}
      baseCurrency={baseCurrency}
      onNext={onNext}
      onPrevious={onPrevious}
    />
  );
};

export default TransferLinkedCapitalActions;
